<script>
  import { page } from '$app/stores';
  import { env as envPublic } from '$env/dynamic/public';

  import '$styles/app/cba_dk/main.scss';

  import Banner from '$components/+banner.svelte';
  import FooterNavigation from '$components/+footerNavigation.svelte';
  import ProfileAvatar from '$components/myAccount/+avatar.svelte';
  import TopNavigation from '$components/+topNavigation.svelte';
  import LocationModal from '$components/locations/+modal.svelte';
  import LocationPage from './find-partners/[uuid]/+page.svelte';

  /** @type {import('./$types').LayoutData} */
  export let data;

  let navigationContent = data.layout.navigation;
  let assetsPath = `${$page.url.origin}/${envPublic.PUBLIC_PUBLISHER}`;
  $: routeName = $page.route.id ? $page.route.id.replace(`/${envPublic.PUBLIC_PUBLISHER}/`, '') : '';
  $: routeClass = $page.url.pathname === '/' ? 'home' : routeName.replace(/\//g, '-');
  $: searchShown = $page.url.pathname !== '/find-partnere';
</script>

<svelte:head>
  <script>
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '%tpl.tagManagerId%');
  </script>
  <title>{envPublic.PUBLIC_APP_NAME}</title>
  <link rel="apple-touch-icon" sizes="180x180" href={`${assetsPath}/favicon/apple-touch-icon.png`} />
  <link rel="icon" type="image/png" sizes="32x32" href={`${assetsPath}/favicon/favicon-32x32.png`} />
  <link rel="icon" type="image/png" sizes="16x16" href={`${assetsPath}/favicon/favicon-16x16.png`} />
  <link rel="manifest" href={`${assetsPath}/favicon/site.webmanifest`} />
  <link rel="mask-icon" href={`${assetsPath}/favicon/safari-pinned-tab.svg`} color="#5bbad5" />
  <meta name="msapplication-TileColor" content="#da532c" />
  <meta name="theme-color" content="#ffffff" />
</svelte:head>

<main class={`page-${routeClass} ${navigationContent.banner.enabled ? 'has-banner' : ''}`}>
  {#if navigationContent.banner.enabled}
    <Banner url={navigationContent.banner.url} text={navigationContent.banner.text} background="gradient" />
  {/if}

  <header class="main">
    <div class="header-wrap">
      <TopNavigation redirectUrl="/find-partnere" logo={navigationContent.logo} items={navigationContent.top_navigation.items} balance={data.balance} loggedIn={data.loggedIn} {searchShown} profileLinks={navigationContent.top_navigation.profile_links} />

      <ProfileAvatar balance={data.balance} loggedIn={data.loggedIn} user={data.user} profileLinks={navigationContent.top_navigation.profile_links} avatarImage={navigationContent.top_navigation.avatar_image} />
    </div>
  </header>

  <slot />

  <FooterNavigation copyright={navigationContent.footer_navigation.copright} logoUrl={navigationContent.footer_navigation.logo_url} contact={navigationContent.footer_navigation.contact} items={navigationContent.footer_navigation.items} />

  <LocationModal templateComponent={LocationPage} />
</main>
